import * as React from "react";
import styled from "@mui/material/styles/styled";
import { ReactComponent as KahunLogo } from "../assets/patientCard/kahunLogo.svg";
//region [[ Styles ]]

const PatientCardTitleRow = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexFlow: "row",
  width: "100%",
});

const LogoAndTitle = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  flex: 1,
  "& > *": {
    margin: "0 22px",
  },
});

const LogoContainer = styled("div")({
  flex: 1,
  display: "flex",
  justifyContent: "flex-start",
});

export const ClinicPatientCardTitle = styled("div")(({ theme }) => ({
  color: "#243443",
  fontWeight: 700,
  fontSize: "32px",
  lineHeight: "35px",
  flex: 2,
  [theme.breakpoints.down("xs")]: {
    display: "none",
  },
}));

const Logo = styled(KahunLogo)(({ theme }) => ({
  "& path": {
    fill: "#5A52C3",
  },
  [theme.breakpoints.down("xs")]: {
    width: "30vw",
  },
}));
//endregion [[ Styles ]]
//region [[ Props ]]
export interface CommonPateintCardRowProps {
  children?: any;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const CommonPatientCardTitleRow = ({
  ...props
}: CommonPateintCardRowProps) => {
  return (
    <PatientCardTitleRow>
      <LogoAndTitle className={"logo-and-title"}>
        <LogoContainer>
          <Logo />
        </LogoContainer>
        <ClinicPatientCardTitle>Patient Assessment</ClinicPatientCardTitle>
      </LogoAndTitle>
      {props.children}
    </PatientCardTitleRow>
  );
};
